const sourceType = [
  { code: '学校', value: '1' },
  { code: '课程方', value: '2' },
  { code: '平台', value: '3' },
]

export default sourceType
